import Presenter from './Presenter';
import { IContainerProps } from './types';

const InputContainer = (props: IContainerProps) => {

    return (
        <Presenter {...props} />
    );
};

export default InputContainer;
